import React, { useEffect } from "react";
import "./common.css";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const removeClass = () => {
    document.getElementById("togglesidebar").classList.remove("active_sidebar");
  };

  return (
    <>
      <div id="sidebar">
        <div className="sidebar_logo d-flex align-items-center justify-content-between border-bottom border-dark">
          <img
            src={require("../assets/images/logo.jpg")}
            alt="logo"
            height="60"
          />
          <i
            className="fa fa-close fs-5 text-danger cursor-pointer"
            onClick={removeClass}
          ></i>
        </div>
        <div className="sidebar_menu flex-grow-1 overflow-auto">
          <ul className="list-unstyled px-2 pt-3">
            <li className="mb-2">
              <Link
                to="/"
                className={`d-flex align-items-center gap-2 px-3 py-2 rounded ${
                  location.pathname === "/" ? "bg-danger" : ""
                }`}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/home.svg").default}
                  alt="home"
                  width="20"
                />
                Home
              </Link>
            </li>
            <li className="mb-2">
              <Link
                to="/devices"
                className={`d-flex align-items-center gap-2 px-3 py-2 rounded ${
                  location.pathname === "/devices" ? "bg-danger" : ""
                }`}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/devices.png")}
                  alt="xtreams"
                  width="20"
                />
                Devices
              </Link>
            </li>
            <li className="mb-2">
              <Link
                to="/xtreams"
                className={`d-flex align-items-center gap-2 px-3 py-2 rounded ${
                  location.pathname === "/xtreams" ? "bg-danger" : ""
                }`}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/onlinedevices.png")}
                  alt="xtreams"
                  width="20"
                />
                Xtreams
              </Link>
            </li>
            <li className="mb-2">
              <Link
                to="/playlists"
                className={`d-flex align-items-center gap-2 px-3 py-2 rounded ${
                  location.pathname === "/playlists" ? "bg-danger" : ""
                }`}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/onlinewatchingplaylist.png")}
                  alt="playlists"
                  width="20"
                />
                Playlists
              </Link>
            </li>
            <li className="mb-2">
              <Link
                to="/disconnectedxtreams"
                className={`d-flex align-items-center gap-2 px-3 py-2 rounded ${
                  location.pathname === "/disconnectedxtreams"
                    ? "bg-danger"
                    : ""
                }`}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/totaldevices.png")}
                  alt="xtreams"
                  width="20"
                />
                Disconnected Xtreams
              </Link>
            </li>
            <li className="mb-2">
              <Link
                to="/settings"
                className={`d-flex align-items-center gap-2 px-3 py-2 rounded ${
                  location.pathname === "/settings" ? "bg-danger" : ""
                }`}
                onClick={removeClass}
              >
                <img
                  src={require("../assets/images/gear-solid.svg").default}
                  alt="settings"
                  width="20"
                />
                Settings
              </Link>
            </li>
            <li className="mt-auto">
              <Link
                to="/login"
                className="d-flex align-items-center gap-2 px-3 py-2 rounded text-danger"
                onClick={() => {
                  localStorage.removeItem("token");
                  localStorage.removeItem("userData");
                  navigate("/login");
                }}
              >
                <img
                  src={require("../assets/images/logout.png")}
                  alt="logout"
                  width="20"
                />
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
export default Sidebar;
